import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

// Admin actions
export const update_seller_commission = createAsyncThunk(
    'commission/update_seller_commission',
    async ({ sellerId, rate, type }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put(`/dashboard/commission/seller/${sellerId}`, 
                { rate, type }
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_seller_commission_details = createAsyncThunk(
    'commission/get_seller_commission_details',
    async ({ sellerId, month, year }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                `/dashboard/commission/seller/${sellerId}?month=${month}&year=${year}`
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const get_all_commissions = createAsyncThunk(
    'commission/get_all_commissions',
    async ({ month, year }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                `/dashboard/commission/all?month=${month}&year=${year}`
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// Seller actions
export const get_my_commission_details = createAsyncThunk(
    'commission/get_my_commission_details',
    async ({ month, year }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                `/dashboard/commission/my-details?month=${month}&year=${year}`
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const commissionReducer = createSlice({
    name: 'commission',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        commissions: [],
        totalCommission: 0,
        totalSales: 0,
        currencySymbol: '',
        currentRate: 0,
        commissionType: 'percentage'
    },
    reducers: {
        messageClear: (state, _) => {
            state.errorMessage = "";
            state.successMessage = "";
        }
    },
    extraReducers: {
        // Update seller commission
        [update_seller_commission.pending]: (state, _) => {
            state.loader = true;
        },
        [update_seller_commission.rejected]: (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload.message;
        },
        [update_seller_commission.fulfilled]: (state, { payload }) => {
            state.loader = false;
            state.successMessage = payload.message;
        },

        // Get seller commission details
        [get_seller_commission_details.pending]: (state, _) => {
            state.loader = true;
        },
        [get_seller_commission_details.rejected]: (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload.message;
        },
        [get_seller_commission_details.fulfilled]: (state, { payload }) => {
            state.loader = false;
            state.commissions = payload.commissions;
            state.totalCommission = payload.totalCommission;
            state.totalSales = payload.totalSales;
        },

        // Get all commissions
        [get_all_commissions.pending]: (state, _) => {
            state.loader = true;
        },
        [get_all_commissions.rejected]: (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload.message;
        },
        [get_all_commissions.fulfilled]: (state, { payload }) => {
            state.loader = false;
            state.commissions = payload.commissions;
            state.totalCommission = payload.totalCommission;
            state.totalSales = payload.totalSales;
            state.currencySymbol = payload.currencySymbol || '';
        },

        // Get my commission details
        [get_my_commission_details.pending]: (state, _) => {
            state.loader = true;
        },
        [get_my_commission_details.rejected]: (state, { payload }) => {
            state.loader = false;
            state.errorMessage = payload.message;
        },
        [get_my_commission_details.fulfilled]: (state, { payload }) => {
            state.loader = false;
            state.commissions = payload.commissions;
            state.totalCommission = payload.totalCommission;
            state.totalSales = payload.totalSales;
            state.currentRate = payload.currentRate;
            state.commissionType = payload.commissionType;
        }
    }
});

export const { messageClear } = commissionReducer.actions;
export default commissionReducer.reducer; 